import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import type { PresentationSectionProps } from '../../../..'
import SWLink from '../_components/SWLink'
import ContentFeature from '../_components/ContentFeature'

const useStyles = makeStyles<Theme, ExpertCollectionsProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ExpertCollections' }
)

export interface ExpertCollectionsProps {
  classes?: StyleClasses<typeof useStyles>
}

function ExpertCollections(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentFeature
        title={
          <>
            Our Expert <br />
            Collections
          </>
        }
        description={
          <>
            An incredibly versatile range <br />
            of whites and neutrals from <br />
            our experts to suit any style.
          </>
        }
        cta={
          <Grid item>
            <SWLink
              href="https://www.sherwin-williams.com/en-us/color/color-collections/emerald-designer-edition"
              label="Explore Our Collection"
              theme="dark"
            />
          </Grid>
        }
        colorTileA={{
          color: '#7A5F5A',
          colorCode: '6033',
          colorName: 'Bateau Brown',
          darkText: false
        }}
        colorTileB={{
          color: '#E2E0D6',
          colorCode: '6033',
          colorName: 'Nuance',
          darkText: true
        }}
        image={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/expert-collections.png'}
        imageAlt="Sherwin-Williams expert collections"
      />
    </div>
  )
}

export default ExpertCollections
